import { render, staticRenderFns } from "./UserDisabledNotifs.vue?vue&type=template&id=3093b55d&"
import script from "./UserDisabledNotifs.vue?vue&type=script&lang=js&"
export * from "./UserDisabledNotifs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports